import React, { useContext, useState, useCallback } from 'react'
import {
  Paper,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Button,
  Typography,
  Grid,
  makeStyles,
  Box,
  FormControlLabel,
  Switch
} from '@material-ui/core'
import { useForm, Controller } from 'react-hook-form'
import { paramListDefault } from '../misc/paramList'
import { NodeContext } from '../states/NodeContextProvider'
import { SubTreeContext } from '../states/SubtreeContextProvider'
import { subtreeEval } from '../misc/subtreeEval'
import { Alert, AlertTitle } from '@material-ui/lab'
import JSONInput from 'react-json-editor-ajrm/index'
import themes from 'react-json-editor-ajrm/themes'
import locale from 'react-json-editor-ajrm/locale/en'
import JsonAsFormSingle from '../components/fragments/JsonAsFormSingle'
import { Link } from 'react-router-dom'
const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary
  }
}))
const TestSubtree = ({ setTitle }) => {
  setTitle('Test Subtree')
  const classes = useStyles()
  const { nodeState } = useContext(NodeContext)
  const { subtreeState } = useContext(SubTreeContext)
  const { handleSubmit, control } = useForm()
  const [result, setResult] = useState('press test!')
  const [isError, setIsError] = useState(null)
  const [jsonInput, setJsonInput] = useState(paramListDefault)
  const [switchState, setSwitchState] = useState(false)
  const onSubmit = useCallback(
    data => {
      setIsError(null)
      const subtree = subtreeState.subtrees.find(e => e.id === data.subtreeID)
      try {
        const copiedData = JSON.parse(JSON.stringify(jsonInput))
        const evaluatedSub = subtreeEval(subtree, nodeState.nodes, copiedData)
        setResult(evaluatedSub.value + '')
        if (evaluatedSub.error.length > 0) {
          setIsError(evaluatedSub.error)
        }
      } catch (error) {
        setIsError(`Oops! something went wrong. please check configuration.`)
      }
    },
    [subtreeState.subtrees, nodeState.nodes, jsonInput]
  )

  return (
    <>
      <Alert severity='info' style={{ marginBottom: '15px' }}>
        We can test sub-trees by selecting from the dropdown and it will give
        out the leaf value{' '}
        <Link style={{ textDecoration: 'none' }} to='/docs/testing'>
          <strong> Learn more </strong>
        </Link>
      </Alert>

      {isError && (
        <div className={classes.alert}>
          <Alert severity='error'>
            <AlertTitle>Error</AlertTitle>
            <strong>{isError}</strong>
          </Alert>
        </div>
      )}
      <form onSubmit={handleSubmit(onSubmit)} className={classes.root}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <Paper elevation={3} className={classes.paper}>
              <Box display='flex' flexDirection='row-reverse'>
                <FormControlLabel
                  control={
                    <Switch
                      checked={switchState}
                      onChange={() => setSwitchState(!switchState)}
                      name='useJSON'
                      color='primary'
                      inputProps={{ 'aria-label': 'primary checkbox' }}
                    />
                  }
                  label='JSON'
                />
              </Box>
              {switchState ? (
                <JSONInput
                  onChange={e => setJsonInput(JSON.parse(e.json))}
                  id='a_unique_id'
                  placeholder={jsonInput}
                  locale={locale}
                  colors={themes.dark_vscode_tribute}
                  height='100%'
                  width='100%'
                  style={{
                    body: {
                      fontSize: '18px'
                    }
                  }}
                />
              ) : (
                <JsonAsFormSingle setjson={setJsonInput} json={jsonInput} />
              )}
            </Paper>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Paper elevation={3} className={classes.paper}>
              <FormControl
                variant='outlined'
                style={{ width: '100%', marginTop: '10px' }}
              >
                <InputLabel id='demo-simple-select-outlined-label'>
                  Subtree ID
                </InputLabel>
                <Controller
                  as={
                    <Select required>
                      <MenuItem value=''>
                        <em>None</em>
                      </MenuItem>
                      {subtreeState.subtrees &&
                        subtreeState.subtrees.map((e, i) => (
                          <MenuItem key={i} value={e.id}>
                            {e.id}
                          </MenuItem>
                        ))}
                    </Select>
                  }
                  name='subtreeID'
                  rules={{ required: true }}
                  control={control}
                  required
                  defaultValue=''
                />
              </FormControl>
              <Button
                style={{ marginTop: '15px' }}
                fullWidth
                size='large'
                color='primary'
                variant='outlined'
                type='submit'
              >
                TEST
              </Button>

              <Typography
                variant='h5'
                component='h5'
                color='secondary'
                style={{ textAlign: 'center', marginTop: '8px' }}
                gutterBottom
              >
                {result}
              </Typography>
            </Paper>
          </Grid>
        </Grid>
      </form>
    </>
  )
}

export default TestSubtree
